/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import config from '../config/index';
import logo from '../assets/konsultacje.png';
import konsultacjeLogo from '../assets/konsultacje-spoleczne-logo.png';
import eisoftware from '../assets/eisoftware.png';
import rekordmobile from '../assets/rekord-mobile.png';
import fundacjajst from '../assets/fundacjajst-logo.png';
import emaillogo from '../assets/emaillogo.jpg';

const Footer = ({ unit, tenant }) => (
  <footer className="footer">
    <div className="container">
      <div className="row">
        <div className="col-sm-2">
          <img src={`${config.getBlobUrl(tenant.url)}${unit.footerShieldUrl}`} alt="Herb" className="herb" />
        </div>
        <div className="col-sm-3">
          <p>
              <strong>{unit.fullName}</strong><br />
              {unit.address}
          </p>
          <p>
              <strong>Dane kontaktowe</strong><br />
              {unit.phoneNumber}<br />
              {unit.email}
          </p>
        </div>
        <div className="col-sm-2 text-center logo">
            <a href="https://konsultacjejst.pl/" className="logo-link konsultacjejst img-responsive" title="KonsultacjeJST.pl"><img src="/konsultacje/konsultacje-spoleczne-logo.png" alt="KonsultacjeJST.pl" /></a>
        </div>
        <div className="col-sm-3 text-center logo">
            <span>Dostawca usługi</span>
            <a href="https://rekordmobile.com.pl/" className="logo-link ei img-responsive" title="Rekord Mobile"><img src="/konsultacje/rekord-mobile.png" alt="Rekord Mobile" /></a>
        </div>
        <div className="col-sm-2 text-center logo">
            <span>Partner</span>
            <a href="http://innowacyjnejst.pl/" className="logo-link jst img-responsive" title="Fundacja na Rzecz Wsparcia Innowacji w JST"><img src="/konsultacje/fundacjajst-logo.png" alt="Fundacja na Rzecz Wsparcia Innowacji w JST" /></a>
        </div>
      </div>
      <div className="row more-info">
          <div className="col-sm-6 text-center">
              <p>KonsultacjeJST.pl &copy; Wszelkie prawa zastrzeżone.</p>
          </div>
          <div className="col-sm-6 text-center">
              <p><a href="/polityka-prywatnosci">Polityka prywatności</a> | <a href="/regulamin">Regulamin</a> | <a href="/mapa-strony">Mapa strony</a> | <a href="/deklaracja-dostepnosci">Deklaracja dostępności</a></p>
          </div>
      </div>
    </div>
  </footer>
);

Footer.propTypes = {
  unit: PropTypes.object,
  tenant: PropTypes.object,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js